"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Surface3 = void 0;
const react_1 = __importStar(require("react"));
//import Container from 'react-bootstrap/Container';
const prop_types_1 = __importDefault(require("prop-types"));
const axios_1 = __importDefault(require("axios"));
// import { IIIFImageLogo } from './iiif-image-logo';
const lbp2_image_text_wrapper_1 = require("@jeffreycwitt/lbp2.image-text-wrapper");
const lbp2_iiif_image_logo_1 = require("@jeffreycwitt/lbp2.iiif-image-logo");
const lbp2_osd_instance_1 = require("@jeffreycwitt/lbp2.osd-instance");
//import {runQuery} from './utils'
//import {getSurfaceInfo, getBlockLines} from './Queries'
//surface id query, gets canvas and manifestation
const getSurfaceInfo = (surfaceid) => {
    const query = [
        "SELECT DISTINCT ?surfaceTitle ?isurface ?isurfaceTitle ?icodexTitle ?canvas ?imageurl ?next_surface ?previous_surface ",
        "{",
        "<" + surfaceid + "> <http://purl.org/dc/elements/1.1/title> ?surfaceTitle .",
        "<" + surfaceid + "> <http://scta.info/property/hasISurface> ?isurface .",
        "OPTIONAL {",
        "<" + surfaceid + "> <http://scta.info/property/next> ?next_surface .",
        "}",
        "OPTIONAL {",
        "<" + surfaceid + "> <http://scta.info/property/previous> ?previous_surface .",
        "}",
        "OPTIONAL {",
        "?isurface <http://purl.org/dc/elements/1.1/title> ?isurfaceTitle .",
        "?isurface <http://purl.org/dc/elements/1.1/isPartOf> ?icodex .",
        "?icodex <http://purl.org/dc/elements/1.1/title> ?icodexTitle .",
        "}",
        "?isurface <http://scta.info/property/hasCanvas> ?canvas .",
        "OPTIONAL{",
        "?canvas <http://iiif.io/api/presentation/2#hasImageAnnotations> ?blank .",
        "}",
        "OPTIONAL{",
        "?canvas <http://www.w3.org/2003/12/exif/ns#height> ?c_height .",
        "}",
        "?blank <http://www.w3.org/1999/02/22-rdf-syntax-ns#first> ?o .",
        "?o <http://www.w3.org/ns/oa#hasBody> ?o2 .",
        "OPTIONAL{",
        "?o2 <http://rdfs.org/sioc/services#has_service> ?imageurl .",
        "}",
        "OPTIONAL{",
        "?o2 <http://www.shared-canvas.org/ns/hasRelatedService> ?imageurl .",
        "}",
        "}"
    ].join('');
    return query;
};
//gets lines and zone order for
const getBlockLines = (manifestationBlockId) => {
    const query = [
        "SELECT ?first ?last ?order ?surface",
        "{",
        "<" + manifestationBlockId + "> <http://scta.info/property/isOnZone> ?zone . ",
        "?zone <http://scta.info/property/isOnZone> ?zone2 .",
        "?zone2 <http://scta.info/property/firstLine> ?first .",
        "?zone2 <http://scta.info/property/lastLine> ?last .",
        "?zone2 <http://scta.info/property/isPartOfSurface> ?surface .",
        "?zone <http://scta.info/property/isOnZoneOrder> ?order .",
        "}"
    ].join('');
    return query;
};
const runQuery = (query) => {
    const sparqlEndpoint = "https://sparql.scta.info/ds/query";
    const queryPromise = axios_1.default.get(sparqlEndpoint, { params: { "query": query, "output": "json" } });
    return queryPromise;
};
const Surface3 = (props) => {
    //const [region, setRegion] = useState("full")
    const [surfaces, setSurfaces] = (0, react_1.useState)([]);
    const [startEndLines, setStartEndLines] = (0, react_1.useState)({});
    // using useRef hook here to track mounted status as recommended here: https://jasonwatmore.com/post/2021/08/27/react-how-to-check-if-a-component-is-mounted-or-unmounted
    const mounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        mounted.current = true;
        setSurfaces([]);
        setStartEndLines({});
        if (props.startWord && props.endWord) {
            getFirstAndLastLineFromWordTokenPositions(props.manifestationid, parseInt(props.startWord), parseInt(props.endWord));
        }
        retrieveSurfaceInfo(props.manifestationid);
        return () => {
            mounted.current = false;
        };
    }, [props.manifestationid, props.startWord, props.endWord]);
    // useEffect(() => {
    // }, [])
    const retrieveSurfaceInfo = (manifestationid) => {
        // manifest id should be retrieved from query
        // this is a temporary measure until db is corrected and query is posible
        const blockLineInfo = runQuery(getBlockLines(manifestationid));
        blockLineInfo.then((d1) => {
            if (d1.data.results.bindings.length > 0) {
                props.handleImagesFound && props.handleImagesFound(true);
                d1.data.results.bindings.forEach((z) => {
                    const surfaceid = z.surface.value;
                    const firstLine = z.first.value;
                    const lastLine = z.last.value;
                    const order = z.order.value;
                    //const manifest = "http://scta.info/iiif/" + this.props.topLevel.split("/resource/")[1] + "/" + surfaceid.split("/resource/")[1].split("/")[0] + "/" + "manifest";
                    const surfaceInfo = runQuery(getSurfaceInfo(surfaceid));
                    surfaceInfo.then((d) => {
                        const b = d.data.results.bindings[0];
                        // only preceed if sparql query returns results
                        if (b) {
                            //second nested async call for annotation list
                            const alUrl = "https://exist.scta.info/exist/apps/scta-app/folio-annotaiton-list-from-simpleXmlCoordinates.xq?surfaceid=" + surfaceid.split("/resource/")[1] + "&coords=loose";
                            axios_1.default.get(alUrl).then((d2) => {
                                //const resources = d2.data.resources
                                if (mounted.current) {
                                    const newSurface = {
                                        currentSurfaceId: surfaceid,
                                        surfaceTitle: b.surfaceTitle ? b.surfaceTitle.value : "",
                                        //manifest: manifest,
                                        canvas: b.canvas.value,
                                        imageurl: b.imageurl.value,
                                        next: b.next_surface ? b.next_surface.value : "",
                                        previous: b.previous_surface ? b.previous_surface.value : "",
                                        annotations: d2.data ? d2.data.resources : "",
                                        surfaceid: surfaceid,
                                        firstLine: firstLine,
                                        lastLine: lastLine,
                                        order: order
                                    };
                                    // need to use prevState here to capture first surface if already set
                                    setSurfaces((prevState) => [...prevState, newSurface]);
                                }
                            });
                        }
                    }).catch((error) => {
                        if (mounted.current) {
                            //   this.setState((prevState) => {
                            const newSurface = {
                                currentSurfaceId: surfaceid,
                                surfaceTitle: b.surfaceTitle.value,
                                //manifest: manifest,
                                canvas: b.canvas.value,
                                imageurl: b.imageurl.value,
                                next: b.next_surface ? b.next_surface.value : "",
                                previous: b.previous_surface ? b.previous_surface.value : "",
                                annotations: "",
                                surfaceid: surfaceid,
                                firstLine: firstLine,
                                lastLine: lastLine,
                                order: order
                            };
                            // need to use prevState here to capture first surface if already set
                            setSurfaces((prevState) => [...prevState, newSurface]);
                        }
                    });
                });
            }
            else {
                props.handleImagesFound && props.handleImagesFound(false);
            }
        });
    };
    const getFirstAndLastLineFromWordTokenPositions = (mid, startWordTokenPosition, endWordTokenPosition) => {
        const tid = mid + "/transcription";
        const results = axios_1.default.get("https://exist.scta.info/exist/apps/scta-app/word-line-lookup.xq?tid=" + tid).then((results) => {
            const d = results.data;
            const firstWordEntry = d[startWordTokenPosition - 1];
            const startLine = firstWordEntry.line;
            //const firstWordLinePosition = firstWordEntry.wordLinePosition
            //const firstWordLineTotal = firstWordEntry.wordLineTotal
            const lastWordEntry = d[endWordTokenPosition - 1];
            const endLine = lastWordEntry.line;
            //const lastWordLinePosition = firstWordEntry.wordLinePosition
            //const lastWordLineTotal = firstWordEntry.wordLineTotal
            const firstPage = firstWordEntry.precedingpb.replace("-", '');
            const endPage = lastWordEntry.precedingpb.replace("-", '');
            const manifestationSlug = mid.split("/")[mid.split("/").length - 1];
            const startSurface = "http://scta.info/resource/" + manifestationSlug + "/" + firstPage;
            const endSurface = "http://scta.info/resource/" + manifestationSlug + "/" + endPage;
            setStartEndLines({ startLine, startSurface, endLine, endSurface });
        }).
            catch((error) => {
            setStartEndLines({});
            console.log("error", error);
        });
    };
    const displayAllImages = (startWordTokenPosition, endWordTokenPosition) => {
        const sortedSurfaces = surfaces.sort((a, b) => {
            if (a.order > b.order)
                return 1;
            if (b.order > a.order)
                return -1;
            return 0;
        });
        const surfacesDisplay = sortedSurfaces.map((surface) => {
            if (startEndLines.startSurface === surface.currentSurfaceId && startEndLines.endSurface === surface.currentSurfaceId) {
                if (startEndLines.startLine < surface.firstLine && startEndLines.endLine < surface.firstLine) {
                    return null;
                }
                // another conditional which handles column breaks on the same surface
                // case where first line is greater than surface first line and last line is still less than surface last line
                // aka when the sub region is contained with the surface
                else if (startEndLines.startLine >= surface.firstLine && startEndLines.endLine <= surface.lastLine) {
                    return displayImages(surface, startEndLines.startLine, startEndLines.endLine);
                }
                // case where first line is greater than surface first but end line is greater than last line of surface
                // aka case where constrained regions starts on first surface, but finishes on second
                else if ((startEndLines.startLine >= surface.firstLine && startEndLines.startLine <= surface.lastLine) && startEndLines.endLine > surface.lastLine) {
                    return displayImages(surface, startEndLines.startLine, undefined);
                }
                // case where first line is less than surface first line but end line is less than surface end line
                // aka case where constrained regions already started on previous surface as is finish on the current surface
                else if (startEndLines.startLine < surface.firstLine && startEndLines.endLine <= surface.lastLine) {
                    return displayImages(surface, undefined, startEndLines.endLine);
                }
            }
            else if (startEndLines.startSurface === surface.currentSurfaceId) {
                return displayImages(surface, startEndLines.startLine);
            }
            else if (startEndLines.endSurface === surface.currentSurfaceId) {
                return displayImages(surface, undefined, startEndLines.endLine);
            }
            else if (!startEndLines.startSurface && !startEndLines.endSurface) {
                return displayImages(surface);
            }
        });
        return surfacesDisplay;
    };
    const displayImages = (surface, startLine, endLine) => {
        const useFirstLine = startLine ? startLine : surface.firstLine;
        const useLastLine = endLine ? endLine : surface.lastLine;
        // handle line display
        if (surface.annotations && props.annotationsDisplay === "lines") {
            const imageTextWrappers = surface.annotations.map((h, i) => {
                if (i + 1 >= useFirstLine && i < useLastLine) {
                    const text = h.resource.chars;
                    const canvas = h.on.split("#xywh=")[0];
                    const canvasShort = canvas.split("/")[canvas.split("/").length - 1];
                    const coords = h.on.split("#xywh=")[1];
                    const imageurl = h.imageUrl;
                    const label = h.label;
                    return (react_1.default.createElement(lbp2_image_text_wrapper_1.ImageTextWrapper, { key: imageurl, imageurl: imageurl, canvas: canvas, coords: coords, canvasShort: canvasShort, text: text, label: label, number: i + 1, targetLabel: props.targetLabel, surfaceButton: false, viewerWidth: props.width }));
                }
                else {
                    return null;
                }
            });
            return imageTextWrappers;
        }
        // handle paragraph and surface display if annotations are available
        else if (surface.annotations) {
            // sometimes surface annotations is an array (tested with surface.annotations.length) sometimes (when there is only one result) it is an object
            const h = surface.annotations.length ? surface.annotations[useFirstLine - 1] : surface.annotations;
            const fl = surface.annotations.length ? surface.annotations[useFirstLine - 1] : surface.annotations;
            const flcanvas = fl ? fl.on.split("#xywh=")[0] : "";
            const flcanvasShort = flcanvas.split("/")[flcanvas.split("/").length - 1];
            const flcoords = fl ? fl.on.split("#xywh=")[1] : "";
            const y = flcoords.split(",")[1];
            const ll = surface.annotations[useLastLine - 1];
            //const llcanvas = ll ? ll.on.split("#xywh=")[0] : ""
            //const llcanvasShort = llcanvas.split("/")[llcanvas.split("/").length - 1];
            const llcoords = ll ? ll.on.split("#xywh=")[1] : "";
            const lly = llcoords.split(",")[1];
            const llh = llcoords.split(",")[3];
            const llbottom = (parseInt(lly) + parseInt(llh)) - parseInt(y);
            //x widens the column by 10, but only if the x is greater than 10
            const x = parseInt(flcoords.split(",")[0]) > 10 ? parseInt(flcoords.split(",")[0]) - 10 : parseInt(flcoords.split(",")[0]);
            const coords = x + "," + (parseInt(y)) + "," + (parseInt(flcoords.split(",")[2]) + 10) + "," + (parseInt(llbottom));
            const text = "";
            const imageurl = h ? h.imageUrl : "";
            // check to see if an Image Url has been found.
            // if not show "error message"
            // get line coordinates for focused line
            let lineFocusCoords = "";
            if (props.lineFocusId) {
                if (!surface.annotations.length) {
                    const h = surface.annotations;
                    const i = 0;
                    if (parseInt(props.lineFocusId.split("/")[props.lineFocusId.split("/").length - 1]) === (i + 1)) {
                        lineFocusCoords = h.on.split("#xywh=")[1];
                    }
                }
                else {
                    surface.annotations.forEach((h, i) => {
                        if (parseInt(props.lineFocusId.split("/")[props.lineFocusId.split("/").length - 1]) === (i + 1)) {
                            lineFocusCoords = h.on.split("#xywh=")[1];
                        }
                    });
                }
            }
            // check if image url exist
            if (imageurl) {
                // create paragraph view port if paragraph view is set 
                if (props.annotationsDisplay === "paragraph") {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(lbp2_image_text_wrapper_1.ImageTextWrapper, { key: surface.currentSurfaceId + "-" + surface.order, imageurl: imageurl, canvas: flcanvas, coords: coords, canvasShort: flcanvasShort, text: text, label: "", targetLabel: "", surfaceButton: false, viewerWidth: props.width, lineFocusCoords: lineFocusCoords })));
                }
                // create whole surface view 
                else if (props.annotationsDisplay === "surface") {
                    return react_1.default.createElement(lbp2_osd_instance_1.OSDInstance, { key: surface.currentSurfaceId + "-" + surface.order, imageurl: surface.imageurl, annotationsDisplay: "surface", coords: coords, constrainViewerToCoords: true, viewerWidth: props.width });
                }
            }
            // if no imageurl exists display "no image" message
            else {
                return (react_1.default.createElement("p", { key: surface.currentSurfaceId + "-" + surface.order }, "Sorry, this image is not yet ready"));
            }
        }
        // if no annotations exist, just display full surface without coords
        else {
            if (imageurl) {
                return react_1.default.createElement(lbp2_osd_instance_1.OSDInstance, { key: surface.currentSurfaceId + "-" + surface.order, imageurl: surface.imageurl, annotationsDisplay: "surface", viewerWidth: props.width });
                // <img key={surface.currentSurfaceId + "-" + surface.order} alt="manuscript" src={surface.imageurl + "/full/" + props.width + ",/0/default.jpg"}/>
            }
            else {
                return null;
            }
        }
    };
    return (react_1.default.createElement("div", { className: props.hidden ? "hidden" : "showing" },
        displayAllImages(props.startWord, props.endWord),
        react_1.default.createElement(lbp2_iiif_image_logo_1.IIIFImageLogo, { imageurl: surfaces[0] ? surfaces[0].imageurl : " " })));
};
exports.Surface3 = Surface3;
Surface3.defaultProps = {
    manifestationid: "http://scta.info/resource/l1-cpspfs/reims",
    annotationsDisplay: "paragraph",
    width: 750
};
Surface3.propTypes = {
    /**
    * a string indicating desired width in pixels for image display
    *
    * TODO: it might be desireable to change propType to an integer. I'm not sure.
    */
    width: prop_types_1.default.number,
    /**
    * manifestation id
    */
    manifestationid: prop_types_1.default.string,
    /**
    * indicates what kind of display is desired, "lines, paragraph, surface/null"
    */
    annotationsDisplay: prop_types_1.default.string,
    /**
     * @description an optional function passed down by the parent.
     * the function will return a boolean, true if a surface is found, or false if not found
     * this alert is useful in the parent component wants to make ux decisions based on whether or not there are images
     * associated with the respective manifestation id. But whether or not there are images won't be known until
     * this component is mounted. Once mounted, it can return true or false and the parent component can respond accordingly.
     */
    handleImagesFound: prop_types_1.default.func,
    /**
     * @descriptions props.startWord is the word token position that the desired passage begins on
     */
    startWord: prop_types_1.default.number,
    /**
     * @descriptions props.endWord is the word token position that the desired passage begins on
     */
    endWord: prop_types_1.default.number
};
//# sourceMappingURL=surface3.js.map